var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardChipIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5835 32.0833V11.9167C4.5835 9.9 6.2335 8.25 8.25016 8.25H35.7502C37.7668 8.25 39.4168 9.9 39.4168 11.9167V32.0833C39.4168 34.1 37.7668 35.75 35.7502 35.75H8.25016C6.2335 35.75 4.5835 34.1 4.5835 32.0833Z",
    fill: "#FF9800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4168 19.2498V17.4165H28.4168C27.4085 17.4165 26.5835 16.5915 26.5835 15.5832C26.5835 14.5748 27.4085 13.7498 28.4168 13.7498H29.3335V11.9165H28.4168C26.4002 11.9165 24.7502 13.5665 24.7502 15.5832C24.7502 17.5998 26.4002 19.2498 28.4168 19.2498H31.1668V24.7498H28.4168C25.8502 24.7498 23.8335 26.7665 23.8335 29.3332C23.8335 31.8998 25.8502 33.9165 28.4168 33.9165H30.2502V32.0832H28.4168C26.8585 32.0832 25.6668 30.8915 25.6668 29.3332C25.6668 27.7748 26.8585 26.5832 28.4168 26.5832H39.4168V24.7498H33.0002V19.2498H39.4168ZM15.5835 24.7498H12.8335V19.2498H15.5835C17.6002 19.2498 19.2502 17.5998 19.2502 15.5832C19.2502 13.5665 17.6002 11.9165 15.5835 11.9165H12.8335V13.7498H15.5835C16.5918 13.7498 17.4168 14.5748 17.4168 15.5832C17.4168 16.5915 16.5918 17.4165 15.5835 17.4165H4.5835V19.2498H11.0002V24.7498H4.5835V26.5832H15.5835C17.1418 26.5832 18.3335 27.7748 18.3335 29.3332C18.3335 30.8915 17.1418 32.0832 15.5835 32.0832H13.7502V33.9165H15.5835C18.1502 33.9165 20.1668 31.8998 20.1668 29.3332C20.1668 26.7665 18.1502 24.7498 15.5835 24.7498Z",
    fill: "#FFD54F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardChipIcon);
export default __webpack_public_path__ + "static/media/cardChip_icon.3ac09d3e4ab3d56d4620c0e95e0d2462.svg";
export { ForwardRef as ReactComponent };